import React from 'react';
import { useTranslation } from 'react-i18next';
import { humanReadableSource } from '../utils/humanReadableSource';
import './ChartAttribution.css';

/** Mark-only (no navy tile) — matches AppHeader geometry, theme via currentColor. */
const OikraMark = ({ size = 18 }) => (
  <svg
    className="chart-attribution__logo"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
  >
    <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="2" />
    <path
      d="M8 20 L12 12 L16 16 L20 8 L24 20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChartAttribution = ({ source, showWatermark = true, className = '' }) => {
  const { t } = useTranslation();
  const displaySource = humanReadableSource(source) || t('ui.chartSourceUnavailable');

  return (
    <div className={`chart-attribution ${className}`.trim()}>
      {showWatermark && (
        <div className="chart-attribution__watermark" aria-hidden="true">
          <OikraMark />
          <span>OIKRA</span>
        </div>
      )}
      <div className="chart-attribution__source">
        <span>{t('reportWidgets.chartSourcePrefix')}:</span> {displaySource}
      </div>
    </div>
  );
};

export default ChartAttribution;
